import { Injectable } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { Observable } from 'rxjs';
import { CategoryDto, CategoryCreateDto, CategoryUpdateDto } from './category.model';

@Injectable({ providedIn: 'root' })
export class CategoryService {
  constructor(private api: ApiService) {}

  // Public list
  listAll(): Observable<CategoryDto[]> {
    return this.api.get<CategoryDto[]>('/categorias');
  }

  // Admin list (paged). Returns { data: CategoryDto[], meta: { total, page, pageSize } }
  adminList(page = 1, pageSize = 20): Observable<{ data: CategoryDto[]; meta?: any }> {
    return this.api.get<any>('/admin/categorias', { page, pageSize });
  }

  get(id: string) {
    return this.api.get<CategoryDto>(`/admin/categorias/${id}`);
  }

  create(payload: CategoryCreateDto) {
    return this.api.post<CategoryDto>('/admin/categorias', payload);
  }

  update(id: string, payload: CategoryUpdateDto) {
    return this.api.put<CategoryDto>(`/admin/categorias/${id}`, payload);
  }

  delete(id: string) {
    return this.api.delete(`/admin/categorias/${id}`);
  }
}
